var _a;
import { createSlice } from '@reduxjs/toolkit';
export var projectUpdatedStatuses = {
    default: 'default',
    saving: 'saving',
    saved: 'saved',
    error: 'error',
};
export var workspaceAlertTypes = {
    error: 'error',
    warning: 'warning',
    notification: 'notification',
};
var initialState = {
    showProjectUpdatedAt: false,
    projectUpdatedStatus: projectUpdatedStatuses.default,
    projectUpdatedAt: undefined,
    // This is the legacy project name. The lab2 project
    // name is part of lab2Redux, in the channel.
    projectName: '',
    projectNameFailure: undefined,
    showTryAgainDialog: false,
    workspaceAlert: null,
    inRestrictedShareMode: false,
    teacherHasConfirmedUploadWarning: false,
};
var projectReduxSlice = createSlice({
    name: 'project',
    initialState: initialState,
    reducers: {
        showProjectUpdatedAt: function (state) {
            state.showProjectUpdatedAt = true;
        },
        setProjectUpdatedError: function (state) {
            state.projectUpdatedStatus = projectUpdatedStatuses.error;
        },
        displayWorkspaceAlert: {
            reducer: function (state, action) {
                state.workspaceAlert = action.payload;
            },
            prepare: function (type, message, displayBottom) {
                return { payload: { type: type, message: message, displayBottom: displayBottom } };
            },
        },
        closeWorkspaceAlert: function (state) {
            state.workspaceAlert = null;
        },
        setProjectUpdatedSaving: function (state) {
            state.projectUpdatedStatus = projectUpdatedStatuses.saving;
        },
        setProjectUpdatedSaved: function (state) {
            state.projectUpdatedStatus = projectUpdatedStatuses.saved;
        },
        setProjectUpdatedAt: function (state, action) {
            state.projectUpdatedAt = action.payload;
            state.projectUpdatedStatus = projectUpdatedStatuses.saved;
        },
        refreshProjectName: function (state) {
            state.projectName = dashboard.project.getCurrentName();
        },
        setShowTryAgainDialog: function (state, action) {
            state.showTryAgainDialog = action.payload;
        },
        setNameFailure: function (state, action) {
            state.projectNameFailure = action.payload;
        },
        unsetNameFailure: function (state) {
            state.projectNameFailure = undefined;
        },
        refreshInRestrictedShareMode: function (state) {
            state.inRestrictedShareMode = dashboard.project.inRestrictedShareMode();
        },
        refreshTeacherHasConfirmedUploadWarning: function (state) {
            state.teacherHasConfirmedUploadWarning =
                dashboard.project.teacherHasConfirmedUploadWarning();
        },
    },
});
export var showProjectUpdatedAt = (_a = projectReduxSlice.actions, _a.showProjectUpdatedAt), setProjectUpdatedError = _a.setProjectUpdatedError, displayWorkspaceAlert = _a.displayWorkspaceAlert, closeWorkspaceAlert = _a.closeWorkspaceAlert, setProjectUpdatedSaving = _a.setProjectUpdatedSaving, setProjectUpdatedSaved = _a.setProjectUpdatedSaved, setProjectUpdatedAt = _a.setProjectUpdatedAt, refreshProjectName = _a.refreshProjectName, setShowTryAgainDialog = _a.setShowTryAgainDialog, setNameFailure = _a.setNameFailure, unsetNameFailure = _a.unsetNameFailure, refreshInRestrictedShareMode = _a.refreshInRestrictedShareMode, refreshTeacherHasConfirmedUploadWarning = _a.refreshTeacherHasConfirmedUploadWarning;
export default projectReduxSlice.reducer;
